import { createContext, PropsWithChildren, useCallback, useMemo, useState } from 'react';

type ChildPositionContextValue = {
  register: (id: string) => void;
  unregister: (id: string) => void;
  itemIds: string[];
};

export const ChildPositionContext = createContext<ChildPositionContextValue | null>(null);

export function ChildPositionProvider({ children }: PropsWithChildren) {
  const [itemIds, setItemIds] = useState<string[]>(() => []);

  const register = useCallback((id: string) => {
    setItemIds((prev) => [...prev, id]);
  }, []);

  const unregister = useCallback((id: string) => {
    setItemIds((prev) => prev.filter((itemId) => itemId !== id));
  }, []);

  const contextValue = useMemo(
    () => ({
      itemIds,
      register,
      unregister,
    }),
    [itemIds, register, unregister],
  );

  return <ChildPositionContext.Provider value={contextValue}>{children}</ChildPositionContext.Provider>;
}
